import Vue from "vue";
import Vuex from "vuex";

import User from "./modules/UserVuex";
import Event from "./modules/EventVuex";
import App from "./modules/AppVuex";
import Notification from "./modules/NotificationVuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    App,
    User,
    Event,
    Notification,
  }
});

export default store;
